import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Table, TableHead, TableRow, TableCell, TableBody } from '@material-ui/core';
import { BASE_URL } from '../../../store/config';
import instance from '../../../request/http';
import { roleStr, ADD, EDIT, VIEW, ONGOING, COMPLETED, DISABLED } from '../../../common/common';
import Toast from '../../Layout/components/Toast';
import UserAutoComplete from '../../Components/UserAutoComplete';
import PersonList from './PersonList';
import RichText from '../../Components/RichText';

const Root = styled(Box)({
    width: '100%',
    marginTop: '20px',
    '& .card': {
        width: '100%',
        minHeight: '150px',
        marginRight: '16px',
        boxShadow: '0 0 14px 0 rgba(184,184,184,0.50)',
        '& .content-1': {
            width: '100%',
            padding: '16px',
            backgroundColor: '#fff',
            '& > div': {
                width: '100%',
                '& .status-area': {
                    flex: '1',
                    '& .basic-status': {
                        marginLeft: 'auto',
                    }
                }
            }
        },
        '& .content-2': {
            width: '100%',
            padding: '16px',
        },
        '& table.white': {
            background: '#fff',
        }
    },
    '& .bullet': {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)',
    },
    '& .title': {
        color: '#9B9B9B',
        fontSize: 14,
    },
    '& .c-gray': {
        color: '#9B9B9B',
    },
    '& .bg-gray': {
        backgroundColor: '#fafafa',
    },
    '& .w-30': {
        width: '30%',
    },
    '& .w-100': {
        width: '100%',
    },
    '& .mb-10': {
        marginBottom: '10px',
    },
    '& .mr-5': {
        marginRight: '5px',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#E4E4E4',
        margin: '10px 0',
    },
})

class TaskCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {
                description: "descr iptiond escripti ondescrip tiondes criptiondes crip tionde scrip tion",
                name: "Intranet",
                principal_id: "null",
                principal_name: "null",
                result: {
                    is_existed: false,
                    notes: 'asdfasjdfo'
                },
                status: "ongoing",
            },
        }
    }

    render() {
        const {
            data,
        } = this.state;
        const statusView = (status) => {
            if (status === ONGOING) {
                return <div className="basic-status color-1 c">Ongoing</div>
            } else if (status === COMPLETED) {
                return <div className="basic-status color-2 c">Completed</div>
            } else if (status === DISABLED) {
                return <div className="basic-status color-3 c">Disabled</div>
            } else {
                return <div>--</div>
            }
        }
        const noteView = (result) => {
            console.log(result);
            if (result.is_existed) {
                console.log(result.note);
                return <RichText
                    data={result.note}
                />
            }
        }
        const resultView = (data) => {
            if (data instanceof Array) {
                return <div>
                    {data.map((row, index) => (
                        <div className="flow" key={index}>
                            <div className="line"></div>
                            <div className="w-30">
                                <div className="title">Person Name</div>
                                <div>{row.person_name}</div>
                            </div>
                            <div className="w-30">
                                <div className="title">Relation</div>
                                <div>{row.relation != null ? row.relation : "Client"}</div>
                            </div>
                            <div className="w-30">
                                <div className="title">Existed</div>
                                <div>{row.is_existed ? "Yes" : "No"}</div>
                            </div>
                            <div className="w-100">
                                <div className="title">Similar Clients</div>
                                <div className="flow">
                                    <Table stickyHeader className="table white">
                                        <TableHead>
                                            <TableRow role="checkbox">
                                                <TableCell>Name</TableCell>
                                                <TableCell>Email</TableCell>
                                                <TableCell>Phone</TableCell>
                                                <TableCell>Wechat</TableCell>
                                                <TableCell>Case(s)</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {row.similar_clients.map((row, index) => (
                                                <TableRow key={index} role="checkbox">
                                                    <TableCell>{row.name}</TableCell>
                                                    <TableCell>{row.email}</TableCell>
                                                    <TableCell>{row.phone}</TableCell>
                                                    <TableCell>{row.wechat}</TableCell>
                                                    <TableCell>{row.case.map((row, index) => (row.case_number + ', '))}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            } else {
                return <div>
                    <div className="line"></div>
                    <div>
                        <div className="title">Existed</div>
                        <div>{data.is_existed ? "Yes" : "No"}</div>
                    </div>
                    <div>
                        <div className="title">Note</div>
                        {noteView(data)}
                    </div>
                </div>
            }
        }
        return (
            <Root>
                <div className="card bg-gray v v-t">
                    <div className="content-1 v v-l">
                        <div className="h h-l"><h2>{data.name} </h2>
                            <div className="status-area">{statusView(data.status)}</div>
                        </div>
                        <div>
                            {/*<div className="mb-10">*/}
                            {/*    {data.description}*/}
                            {/*</div>*/}
                            <div className="title">Principal Name</div>
                            <div>{data.principal_name ? data.principal_name : "System Check"}</div>
                        </div>
                    </div>
                    <div className="content-2 f">
                        <div><b> {data.status === ONGOING ? "The principal is working on this..." : "Result"}  </b></div>
                        {resultView(data.result)}
                    </div>
                </div>
            </Root>
        )
    }

    componentWillReceiveProps(nextProps, context) {
        this.initData(nextProps);
    }

    componentDidMount() {
        this.initData();
    }

    initData(nextProps = null) {
        let data = this.props.data;
        if (nextProps) {
            data = nextProps.data;
        }
        if (data) {
            console.log('=======',data);
            // const newData = {
            //     description: data.description,
            //     name: data.name,
            //     principal_id: data.principal_id,
            //     principal_name: data.principal_name,
            //     result: data.result,
            //     status: data.status,
            // }
            this.setState({
                data
            })
        }
    }
}

export default TaskCard;